import type { AwsRum } from "aws-rum-web";

declare global {
  interface Window {
    cwr?: AwsRum;
  }
}

/**
 * Determine if obj is an instance of AwsRum. Normally we could simply do `obj instanceof AwsRum`, but in our world
 * the XB Host app initializes window.cwr with a copy of aws-rum-web from xb-scripts. Since
 * our code would have a different copy of aws-rum-web, comparing prototypes w/ instanceof won't work.
 *
 * To make our determination, we check for a few expected AwsRum keys in obj
 */
export const isAwsRum = (obj: unknown): obj is AwsRum => {
  /**
   * A few known keys from AwsRum's prototype, hard coding like this let's us keep aws-rum-web out of the bundle
   * since all we really need are a few keys for this sanity check, see https://tiny.amazon.com/1730vf424
   */
  const expectedMethods = ["recordError", "recordPageView", "recordEvent"];

  return (
    typeof obj === "object" && obj !== null && expectedMethods.every((key) => typeof (obj as any)?.[key] === "function")
  );
};
